import { isDefined } from "@grandvisionhq/utils";
const priceVatCalc = (price, rate) => {
  const priceExVat = price / (1 + rate);
  const vatAmount = priceExVat * rate;
  return {
    priceExVat,
    vatAmount
  };
};
const calcPrice = (value, isCentAmount = true) => {
  const amount = isCentAmount ? value / 100 : value;
  const price = !isNaN(amount) ? amount.toFixed(2).toString() : "0.00";
  if (price === "0") {
    return "0.00";
  }
  return price;
};
const pushSdAction = (action) => {
  if (typeof window === "undefined") {
    return;
  }
  if (!window.grandvision || !Array.isArray(window.grandvision.actions)) {
    window.grandvision = {
      actions: []
    };
  }
  window.grandvision.actions.push(action);
  if (process.env.NODE_ENV !== "production") {
    console.log("New Structured Data Action pushed to window.grandvision.actions: ", action);
  }
};
const getFacetLabel = (key, facetLabels) => {
  const labelObject = facetLabels.find((facetLabel) => facetLabel.value === key);
  return labelObject ? labelObject.label : "";
};
const FACET_BLACKLIST = ["variants", "attributes", "label", "centAmount"];
const getSanitizedFacetName = (facet, locale) => {
  return facet.split(".").filter((key) => !(key === locale || FACET_BLACKLIST.includes(key))).join("");
};
const getIncludedVatAmount = (rates) => (rates ?? []).find((rate) => rate.includedInPrice)?.amount;
const createPriceSpecification = (specification, sku, isCentAmount = true) => {
  if (!specification) {
    return null;
  }
  if (!isDefined(specification.price)) {
    console.warn(`Variant with SKU ${sku} doesn't have any pricing.`);
    return null;
  }
  const { price, vatRate, currency, validFrom, validThrough } = specification;
  if (!isDefined(vatRate)) {
    console.warn(`No VAT amount found for variant with SKU ${sku}.`);
    return null;
  }
  const { priceExVat, vatAmount } = priceVatCalc(price, vatRate);
  if (!isDefined(priceExVat) || !isDefined(vatAmount)) {
    console.warn(`Missing 'priceExVat' or 'vatAmount'`);
    return null;
  }
  return {
    "@type": "CompoundPriceSpecification",
    name: "Price",
    price: calcPrice(price, isCentAmount),
    priceCurrency: currency,
    valueAddedTaxIncluded: true,
    validFrom,
    validThrough,
    priceComponent: [
      {
        "@type": "UnitPriceSpecification",
        name: "Price excluding VAT",
        price: calcPrice(priceExVat, isCentAmount),
        valueAddedTaxIncluded: false
      },
      {
        "@type": "UnitPriceSpecification",
        name: "VAT",
        price: calcPrice(vatAmount, isCentAmount),
        valueAddedTaxIncluded: true
      }
    ]
  };
};
export {
  calcPrice,
  createPriceSpecification,
  getFacetLabel,
  getIncludedVatAmount,
  getSanitizedFacetName,
  priceVatCalc,
  pushSdAction
};
//# sourceMappingURL=helpers.js.map
